import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"

// import Button from '@mui/material/Button'

export default function FadeControls({
  sortIndex,
  setSortIndex,
}: {
  sortIndex: number
  setSortIndex: (sortIndex: number) => void
}) {
  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Sounds will be ordered based on this value, lowest to highest. When you
        drag and drop a sound, this value will be automatically updated.
      </Typography>
      <Box sx={{ width: 150, pt: 1 }}>
        <TextField
          id="sort-index"
          label="Sorting Index"
          type="number"
          fullWidth
          inputProps={{
            step: 1,
            min: -10000,
            max: 10000,
          }}
          value={sortIndex || 0}
          onChange={(e) => setSortIndex(Number(e.target.value))}
        />
      </Box>
    </Box>
  )
}
